"use client";

import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { ScrollableFlowScreen } from "../UI/ScrollableFlowScreen";
import { ControllableDemo } from "../Demos/ControllableDemo";
import Image from "next/image";

interface ControllableSectionProps {
  onDownloadClick?: () => void;
}

export function ControllableSection(_props: ControllableSectionProps) {
  const controllableRef = useRef<HTMLDivElement>(null);

  // Use the demo container ref for text scroll progress to ensure perfect sync
  const { scrollYProgress } = useScroll({
    target: controllableRef,
    offset: ["start center", "end end"],
  });

  const texts = [
    "Fellou never works in a black box. For every task, it shows you its entire plan, step by step. You have the power to edit, approve, or step in at any moment, ensuring the AI browser always does exactly what you want.",
  ];

  // 第二阶段"Still..." 文本显示 (0.7-1.0, 占总进度30%)
  const stillTextOpacity = useTransform(scrollYProgress, [0.7, 0.75, 0.9, 1.0], [0, 1, 1, 1]);

  return (
    <div>
      <ScrollableFlowScreen
        ref={controllableRef}
        onViewportEnter={() => console.log("Controllable entered")}
        compact={true}
      >
        <div className="flex min-h-[400vh]">
          {/* Left Half - Text Effect Fixed on Screen */}
          <div className="w-1/2 flex justify-center items-center px-8 sticky top-0 h-screen">
            <motion.div className="max-w-[600px] space-y-12">
              <h2 className="text-4xl font-bold text-white/90 mb-8 w-full">
                Intervene at Any Step of AI Workflows in Real Time
              </h2>
              {texts.map((text, index) => (
                <div key={index} className="text-2xl font-medium text-white/90 leading-relaxed">
                  {text}
                </div>
              ))}

              {/* Still Text - 第二阶段文本显示 (0.7-1.0) */}
              <motion.div className="space-y-8" style={{ opacity: stillTextOpacity }}>
                <div className="text-3xl font-bold text-white/90 leading-tight">
                  <div className="flex items-center gap-2 relative mb-4">Still can&apos;t step in when AI messes up?</div>
                  <div className="flex items-center gap-2">
                    <div className="relative flex-shrink-0 size-8">
                      <Image
                        src="/favicon.ico"
                        alt="fellou"
                        fill
                        priority
                        unoptimized
                        className="rounded p-0.5 ring-1 ring-white/20"
                      />
                    </div>
                    <div>Fellou gives you real-time control.</div>
                  </div>
                </div>
              </motion.div>
            </motion.div>
          </div>

          {/* Right Half - Sticky Demo */}
          <div className="w-1/2 flex justify-center items-center px-8 sticky top-0 h-screen">
            <ControllableDemo containerRef={controllableRef} />
          </div>
        </div>
      </ScrollableFlowScreen>
    </div>
  );
}
